/**
 * Matches a valid agency (G code): G followed by one digit, then 4 alphanumeric characters
 * excluding vowels and certain other letters (same character set as the server-side regex).
 * Examples: G12345, G1BCDF
 */
export const agencyIdRegex = /^G\d[\dBCDFGHJKLMNPQRSTVWXYZ]{4}$/i;

/**
 * Matches a valid agent (I code): I followed by one digit, then 5 alphanumeric characters
 * excluding vowels and certain other letters (same character set as the server-side regex).
 * Examples: I123456, I1BCDFF
 */
export const agentIdRegex = /^I\d[\dBCDFGHJKLMNPQRSTVWXYZ]{5}$/i;
